// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"54274958","730":"75ed0da6","810":"e7d7bebf"}[chunkId] + ".chunk.js";
};